import { ValidationGenerator } from "../../../../../form/validation/validation-generator"
import { ChannelValidationSetting } from "../../../../../form/validation/validation-setting"
import { IFormField } from "./form-meta"

export const validate = (values: Partial<IFormField>) => {
  const errors: Partial<IFormField> = {}
  const channelNameVal = ValidationGenerator(
    values.name,
    ChannelValidationSetting.name,
  )
  const channelScreenNameVal = ValidationGenerator(
    values.screenName,
    ChannelValidationSetting.screenName,
  )
  const channelDescriptionNameVal = ValidationGenerator(
    values.description,
    ChannelValidationSetting.description,
  )

  if (channelNameVal) {
    errors.name = channelNameVal
  }

  if (channelScreenNameVal) {
    errors.screenName = channelScreenNameVal
  }

  if (channelDescriptionNameVal) {
    errors.description = channelDescriptionNameVal
  }

  return errors
}
